import styled from 'styled-components'

const Progress = styled.div<{ background: string }>`
  width: 100%;
  height: 8px;
  background: ${({ background }) => background};
  border-radius: 12px;
  position: relative;
  transform-origin: 100%;
  display: flex;
  align-items: center;
`

const BarWrapper = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: absolute;
`

const Bar = styled.div<{ foreground: string; percent: number }>`
  background: ${({ foreground }) => foreground};
  transform: scaleX(${({ percent }) => percent});
  transform-origin: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all 500ms;
`

interface ProgressBarProps {
  percent: number
  background: string
  foreground: string
  className?: string
}
export const ProgressBar = ({
  percent = 0,
  background,
  foreground,
  className,
}: ProgressBarProps): JSX.Element => {
  if (percent < 0) percent = 0
  if (percent > 1) percent = 1

  return (
    <Progress className={className} role='progressbar' background={background}>
      <BarWrapper>
        <Bar percent={percent} foreground={foreground} />
      </BarWrapper>
    </Progress>
  )
}
